module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('button', {
    attrs: {
      "title": "start",
      "disabled": _vm.isStarted && !_vm.isPaused
    },
    on: {
      "click": _vm.start
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-play"
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "title": "pause",
      "disabled": !_vm.isStarted || _vm.isPaused
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-pause"
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "title": "stop",
      "disabled": !_vm.isStarted
    },
    on: {
      "click": _vm.stop
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-stop"
  })]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStarted && !_vm.isPaused && _vm.isWorking),
      expression: "isStarted && !isPaused && isWorking"
    }],
    staticClass: "toggle-volume glyphicon",
    class: {
      'glyphicon-volume-off': _vm.isSoundEnabled,
      'glyphicon-volume-up': !_vm.isSoundEnabled
    },
    on: {
      "click": _vm.toggleSound
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48f1dd98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ControlsComponent.vue
// module id = 50
// module chunks = 2